export default __webpack_public_path__ + "static/media/TerryNielsen.1419c988.jpg";